<script setup>
import { ref, onMounted } from 'vue';
import MDTextPreview from '../MDTextPreview.vue';

const props = defineProps({
    childrenJson: {
        type: String,
        default: '[]'
    }
});

const children = ref([]);

onMounted(() => {
    children.value = JSON.parse(props.childrenJson || '[]');
});

function addChild() {
    children.value.push({
        title: '',
        text: '',
        order: 0
    });
}

function removeChild(index) {
    children.value.splice(index, 1);
}
</script>

<template>
    <div>
        <h5>Unterabschnitte</h5>
        <div v-for="(child, idx) in children" :key="idx" class="card p-2 mb-2">
            <input type="hidden" :name="`children[${idx}][id]`" v-if="child.id" :value="child.id" />
            <div class="form-group">
                <label>Titel</label>
                <input class="form-control" :name="`children[${idx}][title]`" v-model="child.title" required />
            </div>
            <div class="form-group">
                <label>Text</label>
                <div class="md-text-input">
                    <textarea class="form-control" :name="`children[${idx}][text]`" v-model="child.text"
                        required></textarea>
                    <MDTextPreview :content="child.text" />
                </div>
            </div>
            <div class="form-group">
                <label>Order</label>
                <input class="form-control" type="number" :name="`children[${idx}][order]`" v-model="child.order" />
            </div>
            <button class="btn btn-sm btn-outline-danger" type="button" @click="removeChild(idx)">Löschen</button>
        </div>
        <button class="btn btn-sm btn-outline-primary" type="button" @click="addChild">Kind hinzufügen</button>
    </div>
</template>

<style scoped>
.md-text-input {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    gap: 16px;
}

.md-text-input textarea,
.md-text-input .md-text-preview {
    flex: 1;
}

.md-text-input textarea {
    width: 100%;
    height: 150px;
}
</style>